import * as moment from "moment";
import { database, auth } from "../firebase";
import fetch from "node-fetch";
import { requestActiveCompanyDetails } from "../../redux/actions/single-list";

export const retrieveListDetails = async (info) => {
  try {
    const list = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("lists")
      .doc(info.id)
      .get();
    if (list.data().apiLink) {
      const deletionStore = [];

      const details = await fetch(`/api/brreg/fetch-list`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: list.data().apiLink }),
      });
      const data = await details.json();

      const allDeletions = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("lists")
        .doc(info.id)
        .collection("deletions")
        .get();

      if (allDeletions.size > 0) {
        allDeletions.forEach((deletion) => {
          deletionStore.push(deletion.id);
        });

        return Promise.all(deletionStore).then((result) => {
          if (data && data._embedded.enheter) {
            const filter = data._embedded.enheter.filter(
              (f) => !result.includes(f.organisasjonsnummer)
            );
            return { error: null, payload: filter };
          }
        });
      } else {
        return { error: null, payload: data._embedded.enheter };
      }
    } else {
      throw new Error("Kunne ikke hente listedetaljer.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveListResponses = async (details) => {
  try {
    const responseList = [];
    const allResponses = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("responses")
      .get();
    if (allResponses.size > 0) {
      allResponses.forEach((response) => {
        responseList.push({
          id: response.id,
          organizationNumber: response.data().organizationNumber,
          response: response.data().response,
        });
      });
    }
    return Promise.all(responseList).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveCompanyDetails = async (details) => {
  try {
    if (details.organizationNumber) {
      const response = await fetch(
        `/api/1881/details/${details.organizationNumber}`
      );
      const data = await response.json();

      if (data && data.payload && Object.keys(data.payload).length > 0) {
        var leadObject = {
          general: {
            name: null,
            organizationNumber: null,
            industry: null,
            employees: null,
            parentCompany: {
              id: null,
              infoUrl: null,
              name: null,
              organizationNumber: null,
            },
            established: null,
            shareCapital: null,
            roles: [],
            shareholders: [],
          },
          financials: {
            creditRating: {
              date: null,
              description: null,
              rating: null,
            },
          },
          address: {
            street: null,
            postalCode: null,
            city: null,
            coordinates: null,
            county: null,
            municipality: null,
            region: null,
          },
          contact: {
            phone: null,
            email: null,
            website: null,
          },
          social: {
            twitter: null,
            facebook: null,
          },
        };

        if (data.payload.name) {
          leadObject.general.name = data.payload.name;
        }

        if (data.payload.organizationNumber) {
          leadObject.general.organizationNumber =
            data.payload.organizationNumber;
        }

        if (data.payload.industries) {
          leadObject.general.industry = data.payload.industries[0].name;
        }

        if (
          data.payload.legalInformation &&
          data.payload.legalInformation.employees
        ) {
          leadObject.general.employees =
            data.payload.legalInformation.employees;
        }

        if (
          data.payload.legalInformation &&
          data.payload.legalInformation.parentCompany
        ) {
          leadObject.general.parentCompany =
            data.payload.legalInformation.parentCompany;
        }

        if (data.payload.established) {
          leadObject.general.established = moment(
            data.payload.established
          ).unix()
            ? moment(data.payload.established).unix()
            : null;
        }

        if (
          data.payload.legalInformation &&
          data.payload.legalInformation.shareCapital
        ) {
          leadObject.general.shareCapital =
            data.payload.legalInformation.shareCapital;
        }

        if (data.payload.roles) {
          leadObject.general.roles = data.payload.roles;
        }

        if (data.payload.shareHolders) {
          leadObject.general.shareholders = data.payload.shareHolders;
        }

        if (data.payload.creditRating) {
          if (data.payload.creditRating.date) {
            leadObject.financials.creditRating.date =
              data.payload.creditRating.date;
          }
          if (data.payload.creditRating.rating) {
            leadObject.financials.creditRating.rating =
              data.payload.creditRating.rating;
          }
          if (data.payload.creditRating.description) {
            leadObject.financials.creditRating.description =
              data.payload.creditRating.description;
          }
        }

        if (data.payload.geography && data.payload.geography.coordinate) {
          leadObject.address.coordinates = data.payload.geography.coordinate;
        }

        if (
          data.payload.geography &&
          data.payload.geography.address &&
          data.payload.geography.address.street &&
          data.payload.geography.address.houseNumber
        ) {
          leadObject.address.street = `${data.payload.geography.address.street} ${data.payload.geography.address.houseNumber}`;
        }

        if (
          data.payload.geography &&
          data.payload.geography.address &&
          data.payload.geography.address.postCode
        ) {
          leadObject.address.postalCode =
            data.payload.geography.address.postCode;
        }

        if (
          data.payload.geography &&
          data.payload.geography.address &&
          data.payload.geography.address.postArea
        ) {
          leadObject.address.city = data.payload.geography.address.postArea;
        }

        if (
          data.payload.geography &&
          data.payload.geography.address &&
          data.payload.geography.region
        ) {
          leadObject.address.region = data.payload.geography.region;
        }

        if (
          data.payload.geography &&
          data.payload.geography.address &&
          data.payload.geography.county
        ) {
          leadObject.address.county = data.payload.geography.county;
        }

        if (
          data.payload.geography &&
          data.payload.geography.address &&
          data.payload.geography.municipality
        ) {
          leadObject.address.municipality = data.payload.geography.municipality;
        }

        if (data.payload.contactPoints) {
          const allContactPoints = data.payload.contactPoints;
          for (var i = 0; i < allContactPoints.length; i++) {
            if (
              allContactPoints[i].type === "MobilePhone" ||
              allContactPoints.type === "Phone"
            ) {
              leadObject.contact.phone = `+47${allContactPoints[i].value}`;
            } else if (allContactPoints[i].type === "Email") {
              leadObject.contact.email = allContactPoints[i].value;
            } else if (
              allContactPoints[i].type === "WebAddress" &&
              allContactPoints[i].value.includes("facebook.com")
            ) {
              leadObject.social.facebook = allContactPoints[i].value;
            } else if (
              allContactPoints[i].type === "WebAddress" &&
              allContactPoints[i].value.includes("twitter.com")
            ) {
              leadObject.social.twitter = allContactPoints[i].value;
            } else if (
              allContactPoints[i].type === "WebAddress" &&
              !allContactPoints[i].value.includes(
                "twitter.com" &&
                  !allContactPoints[i].value.includes("facebook.com")
              )
            ) {
              leadObject.contact.website = allContactPoints[i].value;
            }
          }
        }

        return { error: null, payload: leadObject };
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveCompanyNotes = async (details) => {
  try {
    const storedNotes = [];
    const allNotes = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("lists")
      .doc(details.listId)
      .collection("notes")
      .where("company", "==", parseInt(details.organizationNumber))
      .get();
    if (!allNotes.empty) {
      allNotes.forEach((note) => {
        const single = fetchNoteAuthor(note.id, note.data());
        storedNotes.push(single);
      });
    } else {
      throw new Error("Error");
    }
    return Promise.all(storedNotes).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

const fetchNoteAuthor = (noteId, note) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(note.author)
      .get()
      .then((user) => {
        if (user.exists) {
          resolve({
            timestamp: note.timestamp,
            content: note.content,
            key: noteId,
            thumbnail: user.data().thumbnail,
            author: `${user.data().firstName} ${user.data().lastName}`,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const deleteListCompanyNote = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("lists")
      .doc(details.activeClient)
      .collection("notes")
      .doc(details.key)
      .delete();
    return { payload: null, error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const addListCompanyNote = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("lists")
      .doc(details.key)
      .collection("notes")
      .add(details.note);
    return { payload: null, error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveClientStatus = async (details) => {
  try {
    const clients = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("clients")
      .where("general.organizationNumber", "==", details.organizationNumber)
      .get();
    if (clients.size === 0) {
      return { error: null, payload: "no" };
    } else {
      return { error: null, payload: "yes" };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const addNewClient = async (details) => {
  try {
    if (details.info.general.organizationNumber) {
      const clients = await database
        .collection("companies")
        .doc(details.companyId)
        .collection("clients")
        .where(
          "general.organizationNumber",
          "==",
          details.info.general.organizationNumber
        )
        .get();

      if (clients.empty) {
        const changedObject = details.info;
        changedObject["timestamp"] = moment().unix();
        changedObject["addedBy"] = auth.currentUser.uid;
        changedObject["type"] = "company";

        await database
          .collection("companies")
          .doc(details.companyId)
          .collection("clients")
          .add(changedObject);
        return { error: null, payload: null };
      } else {
        throw new Error("Kunde eksisterer allerede.");
      }
    } else {
      throw new Error("Error");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const removeExistingClient = async (details) => {
  try {
    if (details.info.general.organizationNumber) {
      const ids = [];
      const clients = await database
        .collection("companies")
        .doc(details.companyId)
        .collection("clients")
        .where(
          "general.organizationNumber",
          "==",
          details.info.general.organizationNumber
        )
        .get();
      clients.forEach((client) => {
        ids.push(client.id);
      });
      if (ids.length > 0) {
        await database
          .collection("companies")
          .doc(details.companyId)
          .collection("clients")
          .doc(ids[0])
          .delete();
        return { payload: null, error: null };
      } else {
        throw new Error("Kunne ikke finne selskap.");
      }
    } else {
      throw new Error("error");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const addNewResponse = async (details) => {
  try {
    const allResponses = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("responses")
      .where("organizationNumber", "==", details.organizationNumber)
      .get();
    if (allResponses.size > 0) {
      const storedResponses = [];
      allResponses.forEach((response) => {
        if (response.data().listId === details.listId) {
          if (details.response !== "Erase") {
            const single = database
              .collection("companies")
              .doc(details.companyId)
              .collection("responses")
              .doc(response.id)
              .update({
                response: details.response,
                timestamp: moment().unix(),
              });
            storedResponses.push(single);
          } else {
            const single = database
              .collection("companies")
              .doc(details.companyId)
              .collection("responses")
              .doc(response.id)
              .delete();
            storedResponses.push(single);
          }
        }
      });
      return Promise.all(storedResponses).then((result) => {
        return { error: null };
      });
    } else {
      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("responses")
        .add({
          organizationNumber: details.organizationNumber,
          handledBy: auth.currentUser.uid,
          response: details.response,
          listId: details.listId,
          timestamp: moment().unix(),
        });
      return { error: null };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveCompanyDeletions = async (details) => {
  try {
    const deletions = [];
    const allDeletions = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("lists")
      .doc(details.listId)
      .collection("deletions")
      .get();
    if (allDeletions.size > 0) {
      allDeletions.forEach((deletion) => {
        deletions.push(deletion.id);
      });
    }
    return Promise.all(deletions).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const removeCompanyListing = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("lists")
      .doc(details.listId)
      .collection("deletions")
      .doc(details.organizationNumber)
      .set({ timestamp: moment().unix() });
    return { error: null, payload: details.organizationNumber };
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveContactListSelections = async (info) => {
  try {
    if (info.companyId) {
      const contactLists = [];
      const allContactLists = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("contactLists")
        .get();

      allContactLists.forEach((singleContactList) => {
        contactLists.push({
          id: singleContactList.id,
          title: singleContactList.data().name,
        });
      });

      return Promise.all([contactLists]).then((result) => {
        return { payload: result[0], error: null };
      });
    } else {
      throw "Kunne ikke hente valg.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const addCompanyContactList = async (info) => {
  try {
    if (info.companyId && info.contactList) {
      info.record.timestamp = moment().unix();
      const add = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("contactLists")
        .doc(info.contactList)
        .collection("records")
        .add(info.record);
      return { error: null, payload: "success" };
    } else {
      throw "Kunne ikke legge til kontakt.";
    }
  } catch (e) {
    throw new Error(e);
  }
};
